module.exports = __webpack_public_path__ + "img/20.f5667457.png";